import { PaymentMethodService } from '@wix/cashier-core/dist/src/services/PaymentMethod';
import type {
  IFetchExpressPaymentMethodsResponse,
  IListExpressPaymentMethodsParams,
} from '@wix/cashier-core/dist/src/services/PaymentMethod/types';
import { AuthParams } from '../../types/AuthParams';
import { getAccountId } from './getAccountId';

export type AppIdentityParams = {
  appDefId: string;
  appInstanceId: string;
  auth: AuthParams;
};

type FetchPaymentMethodsConfig = AppIdentityParams & {
  baseURL?: string;
};

export const fetchPaymentMethods = async (
  config: FetchPaymentMethodsConfig,
  params: IListExpressPaymentMethodsParams,
): Promise<IFetchExpressPaymentMethodsResponse> => {
  const { baseURL = '/', appDefId, appInstanceId, auth } = config;
  const paymentMethodsService = new PaymentMethodService({ baseURL, ...auth });

  return paymentMethodsService.fetchExpressPaymentMethods(getAccountId(appDefId, appInstanceId), params);
};
